var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAugmentedReality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.58 113.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#7da2fe;}.cls-2,.cls-3{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-3{fill:#1e83f7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.97,65.86h41.65c17.09,0,30.97,13.87,30.97,30.97v11.3c0,2.43-1.97,4.4-4.4,4.4H5.4c-2.43,0-4.4-1.97-4.4-4.4v-11.3c0-17.09,13.87-30.97,30.97-30.97Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 52.79,
    cy: 35.77,
    rx: 30.45,
    ry: 34.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.96,
    y: 19.42,
    width: 69.66,
    height: 25.81,
    rx: 7.74,
    ry: 7.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 74.11,
    cy: 30.09,
    r: 2.94
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAugmentedReality);
export default __webpack_public_path__ + "static/media/augmented-reality.57caa6ae02bca6d58442145905264689.svg";
export { ForwardRef as ReactComponent };